import React from 'react';
import { duckify, currentCustomer, currentUser, singleDuck, dependentDuck, filterDuck } from 'utils/duckify';
import { faCalendarAlt } from '@fortawesome/pro-light-svg-icons/faCalendarAlt';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { billingAccounts, billingConfigs } from '../../../ducks';
import FontAwesome from '../../../utils/FA';
import withFiltering from '../../../hocs/withFiltering';
import AutopayDateEditor, { formatBillingDays } from '../../billing/AutopayDateEditor';

const ManageAutopayDates = ({
  accounts,
  billingConfig,
  filters,
  user,
  customer,
  allDucksReady
}) => {
  // Pop in instead of placeholder.  Too many placeholders looks busy on this page
  if (!allDucksReady || !accounts.some(x => x)) {
    return <React.Fragment></React.Fragment>;
  }

  const billingAccount = (filters && filters.billing_account_id)
    ? accounts.find(account => account.id === filters.billing_account_id)
    : accounts[0];

  // Hide if no billing account, or if current user is not primary owner
  // Pop in instead of placeholder.  Too many placeholders looks busy on this page
  if (!billingAccount || !billingAccount.autopay
    || billingAccount.user_id !== user.id
    || (!billingConfig.show_parents_additional_days && !billingConfig.show_parents_bi_monthly && !billingConfig.show_parents_four_monthly)
  ) {
    return <React.Fragment></React.Fragment>;
  }

  return (
    <div>
      <h2>
        <FontAwesome icon={faCalendarAlt} nbsp />
        Manage Autopay Dates
      </h2>
      <p>
        {`${customer.name} offers additional Autopay Options. Your current Billing Day(s) are the ${formatBillingDays(billingAccount.autopay_days)}.`}
      </p>

      <AutopayDateEditor billingAccount={billingAccount} billingConfig={billingConfig} />
    </div>
  );
};
ManageAutopayDates.propTypes = {
  accounts: PropTypes.arrayOf(PropTypes.shape({
    autopay: PropTypes.bool,
    new_schedule_start: PropTypes.string,
    expiring_autopay_days: PropTypes.array,
    autopay_days: PropTypes.array
  })).isRequired,
  billingConfig: PropTypes.shape({
    show_parents_additional_days: PropTypes.bool,
    show_parents_bi_monthly: PropTypes.bool,
    show_parents_four_monthly: PropTypes.bool
  }).isRequired,
  filters: PropTypes.shape({}).isRequired,
  user: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  customer: PropTypes.shape({
    name: PropTypes.string
  }).isRequired,
  allDucksReady: PropTypes.bool.isRequired
};

const mapDucksToProps = ({ filters }) => ({
  customer: currentCustomer,
  user: currentUser,
  billingConfig: singleDuck(billingConfigs, 'current'),
  accounts: dependentDuck(
    currentUser,
    ({ value: theCurrentUser }) => filterDuck(billingAccounts, { user_id: theCurrentUser.id })
  )
});

export default compose(
  withRouter,
  withFiltering,
  duckify(mapDucksToProps, () => ({}), () => ({}))
)(ManageAutopayDates);
